import { plainToInstance } from 'class-transformer'
import { Entity } from '@core/entities/entity'
import { IRegisterTemplateDiagramLabel } from '@core/entities/register/RegisterTemplateDiagramLabel'
import { RegisterItemColumn } from '@core/entities/register/RegisterItemColumn'

export class RegisterTemplateDiagramLabel extends Entity<IRegisterTemplateDiagramLabel> {
  propertyId?: string
  property?: RegisterItemColumn
  formula?: { function: any[] }

  public static new(payload: unknown): RegisterTemplateDiagramLabel {
    const entity = plainToInstance(RegisterTemplateDiagramLabel, payload)

    return entity
  }

  public static newFromRegisterItemColumn(
    registerItemColumn: RegisterItemColumn,
    formula?: { function: any[] },
  ): RegisterTemplateDiagramLabel {
    const entity = plainToInstance(RegisterTemplateDiagramLabel, {
      propertyId: registerItemColumn.id,
      formula,
    })

    return entity
  }
}
